import {createContext, useContext, useState} from 'react'

export type ExportModalContextType = {
    isExporting: boolean
    setIsExporting: (isExporting: boolean) => void
}
export const ExportModalContext = createContext<ExportModalContextType | undefined>(undefined)

export const useExportModalContext = () => {
    const context = useContext(ExportModalContext)
    if (!context) {
        throw new Error('useExportModalContext must be used in ExportModalProvider')
    }
    return context
}

export const ExportModalProvider = ({children}: {children: React.ReactNode}) => {
    const [isExporting, setIsExporting] = useState(false)
    return <ExportModalContext.Provider value={{isExporting, setIsExporting}}>{children}</ExportModalContext.Provider>
}
